<div class="job-type">
	<div class="job-type-top">
		<h3><ngx-skeleton-loader [theme]="{ width: '94px'}"></ngx-skeleton-loader></h3>
		<a href="javascript:void(0)"><ngx-skeleton-loader [theme]="{ width: '32px'}"></ngx-skeleton-loader></a>
		<div class="clearfix"></div>
	</div>
	<div class="search-box">
		<div class="form-group">
			<ngx-skeleton-loader [theme]="{ width: '222px'}"></ngx-skeleton-loader>
		</div>
	</div>
	<h4><ngx-skeleton-loader [theme]="{ width: '70px'}"></ngx-skeleton-loader></h4>
	<span class="styled-selectors">
		<ngx-skeleton-loader [theme]="{ width: '150px'}"></ngx-skeleton-loader>
	</span>
	<span class="styled-selectors">
		<ngx-skeleton-loader [theme]="{ width: '150px'}"></ngx-skeleton-loader>
	</span>
	<span class="styled-selectors">
		<ngx-skeleton-loader [theme]="{ width: '150px'}"></ngx-skeleton-loader>
	</span>
</div>
<div class="job-type">
	<div class="job-type-top">
		<h3><ngx-skeleton-loader [theme]="{ width: '94px'}"></ngx-skeleton-loader></h3>
		<a href="javascript:void(0)"><ngx-skeleton-loader [theme]="{ width: '32px'}"></ngx-skeleton-loader></a>
		<div class="clearfix"></div>
	</div>
	<div class="search-box">
		<div class="form-group">
			<ngx-skeleton-loader [theme]="{ width: '222px'}"></ngx-skeleton-loader>
		</div>
	</div>
	<h4><ngx-skeleton-loader [theme]="{ width: '70px'}"></ngx-skeleton-loader></h4>
	<span class="styled-selectors">
		<ngx-skeleton-loader [theme]="{ width: '150px'}"></ngx-skeleton-loader>
	</span>
	<span class="styled-selectors">
		<ngx-skeleton-loader [theme]="{ width: '150px'}"></ngx-skeleton-loader>
	</span>
	<span class="styled-selectors">
		<ngx-skeleton-loader [theme]="{ width: '150px'}"></ngx-skeleton-loader>
	</span>
</div>
<div class="job-type">
	<div class="job-type-top">
		<h3><ngx-skeleton-loader [theme]="{ width: '94px'}"></ngx-skeleton-loader></h3>
		<a href="javascript:void(0)"><ngx-skeleton-loader [theme]="{ width: '32px'}"></ngx-skeleton-loader></a>
		<div class="clearfix"></div>
	</div>
	<div class="search-box">
		<div class="form-group">
			<ngx-skeleton-loader [theme]="{ width: '222px'}"></ngx-skeleton-loader>
		</div>
	</div>
	<h4><ngx-skeleton-loader [theme]="{ width: '70px'}"></ngx-skeleton-loader></h4>
	<span class="styled-selectors">
		<ngx-skeleton-loader [theme]="{ width: '150px'}"></ngx-skeleton-loader>
	</span>
	<span class="styled-selectors">
		<ngx-skeleton-loader [theme]="{ width: '150px'}"></ngx-skeleton-loader>
	</span>
	<span class="styled-selectors">
		<ngx-skeleton-loader [theme]="{ width: '150px'}"></ngx-skeleton-loader>
	</span>
</div>
<div class="job-type">
	<div class="job-type-top">
		<h3><ngx-skeleton-loader [theme]="{ width: '94px'}"></ngx-skeleton-loader></h3>
		<a href="javascript:void(0)"><ngx-skeleton-loader [theme]="{ width: '32px'}"></ngx-skeleton-loader></a>
		<div class="clearfix"></div>
	</div>
	<div class="search-box">
		<div class="form-group">
			<ngx-skeleton-loader [theme]="{ width: '222px'}"></ngx-skeleton-loader>
		</div>
	</div>
	<h4><ngx-skeleton-loader [theme]="{ width: '70px'}"></ngx-skeleton-loader></h4>
	<span class="styled-selectors">
		<ngx-skeleton-loader [theme]="{ width: '150px'}"></ngx-skeleton-loader>
	</span>
	<span class="styled-selectors">
		<ngx-skeleton-loader [theme]="{ width: '150px'}"></ngx-skeleton-loader>
	</span>
	<span class="styled-selectors">
		<ngx-skeleton-loader [theme]="{ width: '150px'}"></ngx-skeleton-loader>
	</span>
</div>
<div class="job-type">
	<div class="job-type-top">
		<h3><ngx-skeleton-loader [theme]="{ width: '94px'}"></ngx-skeleton-loader></h3>
		<a href="javascript:void(0)"><ngx-skeleton-loader [theme]="{ width: '32px'}"></ngx-skeleton-loader></a>
		<div class="clearfix"></div>
	</div>
	<div class="search-box">
		<div class="form-group">
			<ngx-skeleton-loader [theme]="{ width: '222px'}"></ngx-skeleton-loader>
		</div>
	</div>
	<h4><ngx-skeleton-loader [theme]="{ width: '70px'}"></ngx-skeleton-loader></h4>
	<span class="styled-selectors">
		<ngx-skeleton-loader [theme]="{ width: '150px'}"></ngx-skeleton-loader>
	</span>
	<span class="styled-selectors">
		<ngx-skeleton-loader [theme]="{ width: '150px'}"></ngx-skeleton-loader>
	</span>
	<span class="styled-selectors">
		<ngx-skeleton-loader [theme]="{ width: '150px'}"></ngx-skeleton-loader>
	</span>
</div>
